import { message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BarcodeScannerInput from '../pages/BarcodeScannerInput';
import Quagga from "@ericblade/quagga2";

function LabReceived() {
    useEffect(() => {
        document.title = 'GutHealthlab Lab Received Form';
    }, []);

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        qrCode: '',
    });

    const [loading, setLoading] = useState(false);
    const isSubmittingRef = useRef(false);

    const handleBarcodeChange = (code) => {
        setFormData({
            ...formData,
            qrCode: code,
        });
    };

    const submitDataLogic = async (code) => {
        if (isSubmittingRef.current) return;

        if (!formData.qrCode) {
            message.error('Kit ID is required');
            return;
        }

        isSubmittingRef.current = true;
        setLoading(true);

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
            };

            // const apiUrl2 = `${`https://api.yourgutmap.co.uk`}/scankit?kitID=${code}`;
            const apiUrl2 = `${`https://api.yourgutmap.co.uk`}/scankit-test-4-life?kitID=${code}&labType=Test4Life&portalId=67ef8f3a291b7c6b9f6752cf`;
            const response = await fetch(apiUrl2, requestOptions);
            const result = await response.json().catch(() => ({}));

            if (response.ok) {
                message.success(result.message || 'Kit scanned successfully!');
            } else {
                message.error(result.message || 'Something went wrong!');
            }
        } catch (error) {
            message.error('An error occurred while submitting the form');
            console.error(error);
        } finally {
            setFormData({ qrCode: '' });
            setLoading(false);
            isSubmittingRef.current = false;
        }
    };

    const submitData = async (e) => {
        e.preventDefault();
        await submitDataLogic(formData.qrCode);
    };

    return (
        <div style={{ 
            padding: '20px', 
            maxWidth: '500px', 
            margin: '0 auto',
            fontFamily: 'Arial, sans-serif'
        }}>
            {/* Header */}
            <h1 style={{ 
                color: '#19B0E6', 
                fontWeight: 700, 
                marginBottom: '20px',
                fontSize: '24px',
                textAlign: 'center',
                marginTop: '80px'
            }}>
                Kit Received Form
            </h1>

            <form onSubmit={submitData}>
                {/* Kit ID Section */}
                <div style={{ marginBottom: '20px' }}>
    <label style={{
        display: 'block',
        color: '#19B0E6',
        fontWeight: 600,
        marginBottom: '8px',
        fontSize: '16px'
    }}>
        
    </label>
    
    {/* Bigger Input Field */}
    <div style={{
        width: '100%',
        maxWidth: '220%', // Increased from 300px to 500px
        margin: '0 auto'
        
    }}>
        <BarcodeScannerInput
            onDetected={handleBarcodeChange}
            singleScan={true}
            barcodeTypes={["code_128"]}
            placeholder="Type Kit ID"
            value={formData.qrCode}
            autoFocusInput={true}
            className="barcode-input"
        />
    </div>
</div>

                {/* Checkbox Options */}
                <div style={{ 
                    marginBottom: '25px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    alignItems: 'center'
                }}>
                    <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer'
                    }}>
                       
                    </label>
                    
                    <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer'
                    }}>
                        
                    </label>
                </div>

                {/* Send Button */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center',
                    marginTop: '20px'
                }}>
                    <button
                        type="submit"
                        disabled={loading}
                        style={{ 
                            minWidth: '150px',
                            padding: '12px 30px',
                            backgroundColor: loading ? '#ccc' : '#1890ff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '16px',
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                            if (!loading) {
                                e.target.style.backgroundColor = '#40a9ff';
                                e.target.style.transform = 'translateY(-2px)';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!loading) {
                                e.target.style.backgroundColor = '#1890ff';
                                e.target.style.transform = 'translateY(0)';
                            }
                        }}
                    >
                        {loading ? 'Sending...' : 'SEND'}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default LabReceived;